<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html,
  body{
    height: 100%;
    min-height: 100%;
  }
  #app {
    height: 100%;
    min-height: 100%;
  }
  .bg-light {
    background-color: #ffffff !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue